import loadable from '@loadable/component'

export type { ColumnFilterProps } from './ColumnFilter'
export const ColumnFilter = loadable(() => import('./ColumnFilter'))
